module.exports = __webpack_public_path__ + "media/customizations/lmws/logo-e59c89c98cbd96593dd6ed9088f3d79b.png";